import React from 'react';
import { withStyles, Dialog, DialogContent, Typography, Button, Divider,Card ,CardContent } from '@material-ui/core';
import { connect } from 'formik';
import CheckIcon from '@material-ui/icons/Check';
import Logo from '../assets/images/progressBar.png';
import Logo1 from '../assets/images/progressBar1.png';
import iphone from "../assets/images/iphone.png";
import GridContainer from "../components/Grid/GridContainer";
import GridItem from "../components/Grid/GridItem";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import Avatar from '@material-ui/core/Avatar';
import {StatusCodes} from 'http-status-codes';

const styles = theme => ({
    root: {
        paddingLeft: 20,
        paddingRight: 40,
        maxWidth: "1100px",
        margin: "0 auto",
        color:"rgb (23 42 58)",
         textAlign: "center !important",
        [theme.breakpoints.down('sm')]: {
            paddingRight: 0,
            paddingLeft: 0,
        }
    },
   cardroot: {
    minWidth: 220,
  },
  minWidth0:{minWidth:0},
  // img:{width:'50px',height:'50px',borderRadius:' 50%,'},
    closeButton: {
        position: 'absolute',
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[StatusCodes.INTERNAL_SERVER_ERROR],
    },
    icon:{
        color:"rgb(34,98,191)"
    },
    icon1:{
        color:"rgb(191,229,35)",
        paddingLeft:"10px"
    },
icon3:{color:"rgb 142 142 147"},
   title:{color:"rgb( 0 0 102) !important",fontSize: "16px",padding:"5px",
},
  mobileTxt: {
    position: "absolute",
    top: "17%",
    left:'50%',
    width:'100%',
    height:'470px',
    padding:'30px',
    transform:'translate(-50%,-10%)',
    overflowX:'hidden',
    "&::-webkit-scrollbar":{
      width:'12px'
    }
  },
  giri:{
    padding:0,
    overflow:'hidden',
    maxHeight:'100%'
  },
  gir2:{
    overflow:'hidden',
    padding: "0 !important",
    background:'transparent'
  },
div:{marginLeft: "-16px",marginRight: "-16px",},
text1:{color:"rgb(34 98 191)!important",paddingTop:"15px",paddingBottom: "15px",fontSize: "15px"},
text2:{color:"rgb(191 229 35)!important",paddingTop:"15px",paddingBottom: "15px",fontSize: "15px"},
text3:{color:"rgb(116 118 129)!important",paddingTop:"5px",paddingBottom: "15px",fontSize: "15px"},
text4:{color:"rgb( 0 0 102)!important",fontSize: "15px",fontWeight: 'bold',},
text5:{color:"rgb( 0 0 102)!important",paddingTop:"22px",lineHeight:"18pt",letterSpacing:"-.04pt",fontSize: "18px",fontWeight: 'bold',paddingLeft:"5px" ,},
image:{width:"50px",height:"50px",borderRadius:"50%",marginLeft: "5px",marginTop: "9px",marginBottom: "5px",},
text6:{color:"rgb 142 142 147!important",lineHeight:"18pt",letterSpacing:"-.08pt",fontSize: "13px",},
imgcenter:{alignItems: 'center'},
text7:{color:"black !important",lineHeight:"12pt",letterSpacing:"-.54pt",fontSize: "15px",
overflow: "hidden",position: "relative",maxHeight: "2.4em",paddingRight: 1,paddingTop:"2px",paddingBottom: "2px",marginBottom:"8px",},
  paddingBottom: { padding: "0px" },
  paddingTopLeft:{paddingLeft:5},
  arrow:{textAlign: 'right',paddingRight:'8px'}
});

class PreviewTrivia extends React.Component {
  render() {
    const { classes } = this.props;
    const handlechapter = (chapter) => {
      this.props.setChapterPreview(chapter);
      this.props.handleClose();
    };
        return (
            <>
                   <Dialog classes={{paperScrollPaper:"paperScrollPaper"}} open={this.props.open} onClose={this.props.handleClose} maxWidth={"xs"}>
                     <DialogContent className={classes.gir2} style={{ overflowX: 'hidden' }}>
                        <div className={classes.mobile}>
                        <img src={iphone} width="100%" />
                        <div className={classes.mobileTxt}>
                           {this.props.name==="curriculum"?<>
                               <Typography style={{paddingBottom:"10px",textAlign:"center"}}>Title</Typography>
                                 <Divider className={classes.div} />
                                 <Typography className={classes.text5}>{this.props.value.content.coursetitle}</Typography>
                                     <GridContainer>
                                  {this.props.value ?this.props.value.chapter.map((chapters,index)=>
                                 <Card className={classes.cardroot}style={{marginBottom:"4px",}} key={index}>
                                  <GridContainer className={classes.imgcenter}>
                                 <GridItem md={3} lg={3} sm={12} xs={12} className={classes.paddingBottom} >
                                  {chapters.chapterimage.base64Rep ? <Avatar className={classes.img} src={chapters.chapterimage.base64Rep} className={classes.image+" "+"editimage"}/>
                                  : <Avatar className={classes.img} src={chapters.chapterimage} className={classes.image}/>}
                                </GridItem>
                                  <GridItem md={6} lg={6} sm={12} xs={12} className={classes.paddingTopLef}>
                                   <Typography className={classes.text6}> {`Chapter ${index+1}`}</Typography>
                                    <Typography className={classes.text7}>{chapters.title}</Typography>
                                 </GridItem>
                                  <GridItem md={3} lg={3} sm={12} xs={12} className={classes.paddingBottom+ " "+classes.arrow} >
                                   <Button className={classes.paddingBottom+" "+classes.minWidth0} onClick={()=>handlechapter(chapters)} >< ArrowForwardIosIcon className={classes.icon3} /></Button>
                                  </GridItem>
                                  </GridContainer>
                                  </Card>
                                  ):""}</GridContainer>
                            </>
                           :<>     <Typography style={{paddingBottom:"10px",textAlign:"center"}}>Fact/Fiction</Typography>
                                <Typography className={classes.title}style={{paddingLeft:"15px"}}>{this.props.list.content.question}</Typography>
                                   <br/>
                                  <Card className={classes.cardroot}>
                                        <CardContent>
                                              <Typography className={classes.title} style={{fontWeight:"bold",paddingBottom: "5px",}}>{"Here’s what others are saying"}</Typography>
                                           <Divider className={classes.div}/>
                                              <Typography className={classes.text1}>{"33% FICTION"}</Typography>
                                                 <img src={ Logo } style={{paddingBottom:"15px" ,width:"90%"}}></img>
                                             <Divider className={classes.div} />
                                              <Typography className={classes.text2}>{"77% FACT"}</Typography>
                                      <img src={ Logo1 }style={{width:"90%"}}></img>
                                       </CardContent>
                                       </Card>
                                      <br/>
                                      <Card className={classes.cardroot}>
                                      <CardContent>
                                      {this.props.list.content.correctoptionid.label&&<Typography className={classes.text4}>{this.props.list.content.correctoptionid.label}<CheckIcon className={classes.icon1} /></Typography>}
                                     {this.props.list.content.correctoptionid===1&&<Typography className={classes.text4}>{"FACT"}<CheckIcon className={classes.icon1} /></Typography>}
                                     {this.props.list.content.correctoptionid===2&&<Typography className={classes.text4}>{"FICTION"}<CheckIcon className={classes.icon1} /></Typography>}
                                     <Typography className={classes.text3}>{this.props.list.content.responsebody}</Typography>
                                       </CardContent>
                                </Card></>}
                         </div>
                         </div>
                    </DialogContent>
                </Dialog>
            </>
        );
    }
}
export default withStyles(styles)(connect(PreviewTrivia));

